import {
  Fab,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import DashboardIcon from "@mui/icons-material/Dashboard";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import "./MainContent.css";
import ConfirmationTicketModal from "./ConfirmationTicketModal";
const MainContent = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
const [showConfirmationSupportModal, setShowConfirmationSupportModal] = useState(false);

  const userEmail = localStorage.getItem("data");
  const selectedItem = useSelector((state) => state?.selectionSlice?.selectedItem);  


const dispatch = useDispatch();
  const tabDetails = useSelector((state) => state?.dashboardDetails?.tabDetails);

  useEffect(() => {
    // Removed forced pushState / onpopstate that prevented browser back navigation.
    // Back navigation is now handled centrally in `App.js`'s popstate listener.
  }, [dispatch])
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElSecond, setAnchorElSecond] = useState(null);

  const handleForecastClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleForecastSecondMenuClick = (event) => {
    setAnchorElSecond(event.currentTarget);
  };

  const handleForecastClose = () => {
    setAnchorEl(null);
  };

  const handleForecastSecondMenuClose = () => {
    setAnchorElSecond(null);
  };

  const handleAddConfirmationSupportClick = () => {
   setShowConfirmationSupportModal(true);
  };

  return (
    <div
      className={
        tabDetails.title === "Landing" ? "landing-content" : "main-content"
      }
    >
      {(location.pathname !== "/" && location.pathname !== "/login") ? (
        <>
          <div className="sidebar">
            <List sx={{ marginTop: "15px" }} className="sideBarOptionsList">
              {props.menuItems?.map((item) => (
                item.label === "Planning" ? (
                  <>
                    {/* Forecast Button (opens submenu) */}
                    <ListItemButton
                      onClick={handleForecastClick}
                      selected={item.path && location.pathname.startsWith(item.path)}
                      style={{
                        backgroundColor:
                          item.path && location.pathname.startsWith(item.path) ? "#717171" : "#aaaaaa",
                      }}
                      className="listButtonSection"
                    >
                      <ListItemIcon
                        sx={{ minWidth: 0, mr: 3, justifyContent: "center" }}
                        style={{ display: "flex", margin: "auto", color: "#fff" }}
                      >
                        {item.icon}
                      </ListItemIcon>
                      <ListItemText
                        primary={item.label}
                        sx={{
                          opacity: 1,
                          ".MuiTypography-root": {
                            fontSize: "12px !important",
                          },
                        }}
                        style={{ color: "#fff" }}
                      />
                    </ListItemButton>

                    {/* Submenu Popup (MUI Menu) */}
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleForecastClose}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                      PaperProps={{
                        sx: {
                          backgroundColor: "#aaaaaa", // same as sidebar
                          color: "#fff",
                          mt: 0.5,
                          "& .MuiMenuItem-root": {
                            fontSize: "13px",
                            paddingY: "6px",
                            paddingX: "20px",
                            minWidth: "120px",
                          },
                          "& .MuiMenuItem-root:hover": {
                            backgroundColor: "#717171", // hover color same as active
                          },
                        },
                      }}
                    >
                      <MenuItem
                        onClick={handleForecastSecondMenuClick}
                      >
                        Forecast <KeyboardArrowRightIcon />
                      </MenuItem>
                      <Menu
                        anchorEl={anchorElSecond}
                        open={Boolean(anchorElSecond)}
                        onClose={handleForecastSecondMenuClose}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        PaperProps={{
                          sx: {
                            backgroundColor: "#aaaaaa",
                            color: "#fff",
                            mt: -1,
                            ml: 0.5, // horizontal gap between menus
                            "& .MuiMenuItem-root": {
                              fontSize: "13px",
                              paddingY: "6px",
                              paddingX: "20px",
                            },
                            "& .MuiMenuItem-root:hover": {
                              backgroundColor: "#717171",
                            },
                          },
                        }}
                      >
                        <MenuItem
                          onClick={() => {
                            props.handleMenuItemClick("/forecastCollab-cps", item.label, {
                              id: 3,
                              path: "/forecastCollab-cps",
                              label: "Forecast",
                              icon: <DashboardIcon />,
                              title: "Forecast",
                            })
                            setAnchorEl(null);
                            setAnchorElSecond(null)
                          }
                          }
                        >
                          CPS
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            props.handleMenuItemClick("/forecastCollab-dps", item.label, {
                              id: 3,
                              path: "/forecastCollab-dps",
                              label: "Forecast",
                              icon: <DashboardIcon />,
                              title: "Forecast",
                            })
                            setAnchorEl(null);
                            setAnchorElSecond(null);
                          }
                          }
                        >
                          DPS
                        </MenuItem>
                      </Menu>

                    </Menu>
                  </>
                ) :
                  <ListItem
                    key={item.title}
                    disablePadding
                    onClick={() =>
                      props.handleMenuItemClick(item.path, item.label, item)
                    }
                  >
                    <ListItemButton
                      selected={item.path && location.pathname.startsWith(item.path)}
                      style={{
                        backgroundColor:
                          item.path && location.pathname.startsWith(item.path) ? "#717171" : "#aaaaaa",
                      }}
                      className="listButtonSection"
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: 3,
                          justifyContent: "center",
                        }}
                        style={{
                          display: "flex",
                          margin: "auto",
                          color: "#fff",
                        }}
                      >
                        {item.icon}
                      </ListItemIcon>
                      <ListItemText
                        primary={item.label || item.title}
                        sx={{
                          opacity: 1,
                          ".MuiTypography-root": {
                            fontSize: "12px !important",
                          },
                        }}
                        style={{ color: "#fff" }}
                      />
                    </ListItemButton>
                  </ListItem>
              ))
              }
            </List>
          </div>
          <div className="content">
            <div>
              <Outlet context={{ setRiskMaterials: props.setRiskMaterials }} />
            </div>
          </div>
          
          {location?.pathname !== "/sc-ticketsummary" && (
            <Fab
              variant="extended"
              disabled={location.pathname === "/grpt-ticketsummary"}
              style={{
                position: "fixed",
                bottom: "22px",
                left: "2px",
                zIndex: 1000,
                background: `${(location.pathname === "/sc-ticketsummary") ? '#0000001f' : "#64cac6"}`,
                color: "#fff",
                padding: "10px 20px",
              }}
              onClick={handleAddConfirmationSupportClick}
            >
              <AddIcon sx={{ mr: 1 }} />
              Support
            </Fab>
          )}
            
          <ConfirmationTicketModal
            showModal={showConfirmationSupportModal}
            title="Support Ticket"
            handleClose={() => setShowConfirmationSupportModal(false)}
            userEmail={userEmail}
            selectedItem={selectedItem}
          />
        </>
      )
        : <div className="content">
          <div>
            <Outlet context={{ setRiskMaterials: props.setRiskMaterials }} />
          </div>
        </div>
      }
    </div >
  );
};

export default MainContent;
